import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import randomColor from 'randomcolor';

const styles = theme => ({
  pieContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '5px',
  },
  chartTitle: {
    ...theme.Typography,
    color: '#044591',
    height: '5px',
  },
  headerQuestionIcon: {
    marginRight: '15px',
  },
  headerQuestionTitle: {
    display: 'flex',
    color: '#044591',
    marginTop: '15px',
    justifyContent: 'center',
    width: '250px',
  },
  pieInnerContainer: {
    display: 'flex',

    margin: 'auto',
    width: '200px',
  },
  countContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '15px',
  },
  columnCountCorrect: {
    display: 'flex',
    height: '80px',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    paddingRight: '10px',
  },
  columnCountWrong: {
    display: 'flex',
    height: '80px',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  containerNoData: {
    alignSelf: 'center',
    height: '250px',
    lineHeight: '210px',
  },
  legendFont: {
    fontSize: '11px',
  },
  paperPieChart: {
    padding: '15px',
    margin: '5px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '250px',
  },
  responsiveContainer: {
    margin: '15px',
  },
  cellStyle: {
    marginTop: '15px',
  },
});

export const RenderPieChart = ({
  classes,
  question,
  dataChart,
  preview,
  interaction,
  filter,
}) => {
  return (
    <ResponsiveContainer
      width="100%"
      height={160}
      id="chartResponsive"
      className={classes.responsiveContainer}
    >
      <PieChart>
        <Pie
          // width={300}
          // height={300}
          data={dataChart}
          dataKey="total"
          nameKey="title"
          cx="50%"
          cy="50%"
          innerRadius={15}
          outerRadius={35}
          fill="#8884d8"
          isAnimationActive={false}
        >
          {dataChart.map((entry, indexOpt) => {
            let color = randomColor({ seed: indexOpt * 20 });
            if (entry.index === -1) {
              color = '#d9dbde';
            }
            return (
              <Cell
                fill={color}
                key={indexOpt}
                onClick={() => {
                  if (filter) {
                    filter(interaction, question, entry, preview);
                  }
                }}
                className={classes.cellStyle}
              />
            );
          })}
        </Pie>
        <Tooltip />
        <Legend
          className={classes.legendFont}
          wrapperStyle={{ fontSize: '10px', top: 110 }}
          iconSize={11}
          align="center"
          layout="vertical"
          verticalAlign="bottom"
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export const RenderCountData = ({ classes, totalCorrect, totalLeads }) => {
  return (
    <div className={classes.countContainer}>
      <div className={classes.columnCountCorrect}>
        <div>
          <Typography variant="h3" style={{ color: '#6989c9' }}>
            {totalCorrect}
          </Typography>
        </div>
        <div>
          <Typography variant="caption" style={{ color: 'gray' }}>
            Corrects
          </Typography>
        </div>
      </div>

      <div className={classes.columnCountWrong}>
        <div>
          <Typography variant="h5">/{totalLeads}</Typography>
        </div>
        <div>
          <Typography variant="caption" style={{ color: 'gray' }}>
            Total
          </Typography>
        </div>
      </div>
    </div>
  );
};

class PieChartAnalytics extends React.Component {
  render() {
    let { classes, question, preview, filter } = this.props;
    const questionHasData = question.questionHasData;
    const hasRightAnswer = question.hasRightAnswer;
    const dataChart = question.options;
    const totalCorrect = question.totalCorrectAnswers;
    const totalLeads =
      question.totalCorrectAnswers + question.totalWrongAnswers;
    const interaction = question.interaction;
    return (
      <Grid item className={classes.pieContainer}>
        <Paper className={classes.paperPieChart}>
          <div>
            {hasRightAnswer && (
              <RenderCountData
                classes={classes}
                totalCorrect={totalCorrect}
                totalLeads={totalLeads}
              />
            )}
          </div>
          <div style={{ height: '100%' }}>
            <div className={classes.headerQuestionTitle}>
              <LiveHelpIcon className={classes.headerQuestionIcon} />
              <Typography variant="subtitle2" className={classes.chartTitle}>
                {question.questionTitle}
              </Typography>
            </div>

            {questionHasData ? (
              <div className={classes.pieInnerContainer}>
                <RenderPieChart
                  question={question}
                  dataChart={dataChart}
                  classes={classes}
                  preview={preview}
                  interaction={interaction}
                  filter={filter}
                />
              </div>
            ) : (
              <div className={classes.containerNoData}>
                No records to display
              </div>
            )}
          </div>
        </Paper>
      </Grid>
    );
  }
}

export default withStyles(styles)(PieChartAnalytics);
